
import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { 
  Activity, 
  DollarSign, 
  Ticket, 
  BadgePercent, 
  BadgeDollarSign,
  Users
} from "lucide-react";

interface MetricCardProps {
  label: string;
  value: string | number;
  icon: React.ReactNode;
  bgColor: string;
  iconColor: string;
}

const MetricCard = ({ label, value, icon, bgColor, iconColor }: MetricCardProps) => (
  <Card>
    <CardContent className="pt-6">
      <div className="flex items-center justify-between">
        <div className="space-y-1">
          <p className="text-sm font-medium text-muted-foreground">{label}</p>
          <p className="text-2xl font-bold">{value}</p>
        </div>
        <div className={`p-2 ${bgColor} rounded-full`}>
          <div className={`h-4 w-4 ${iconColor}`}>{icon}</div>
        </div>
      </div>
    </CardContent>
  </Card>
);

interface CampaignMetricsCardsProps {
  totalConversions: number;
  totalRevenue: number;
  totalCoupons: number;
  totalReferrals: number;
  conversionRate: number;
  averageOrderValue: number;
}

const CampaignMetricsCards = ({
  totalConversions,
  totalRevenue,
  totalCoupons,
  totalReferrals,
  conversionRate,
  averageOrderValue
}: CampaignMetricsCardsProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      <MetricCard
        label="Conversões"
        value={totalConversions}
        icon={<Activity />}
        bgColor="bg-blue-100 dark:bg-blue-900"
        iconColor="text-blue-600 dark:text-blue-300"
      />
      
      <MetricCard
        label="Receita"
        value={`R$ ${totalRevenue.toLocaleString()}`}
        icon={<DollarSign />}
        bgColor="bg-amber-100 dark:bg-amber-900"
        iconColor="text-amber-600 dark:text-amber-300"
      />

      <MetricCard
        label="Cashback Utilizado"
        value={totalCoupons}
        icon={<Ticket />}
        bgColor="bg-purple-100 dark:bg-purple-900"
        iconColor="text-purple-600 dark:text-purple-300"
      />

      <MetricCard
        label="Indicações"
        value={totalReferrals}
        icon={<Users />}
        bgColor="bg-indigo-100 dark:bg-indigo-900"
        iconColor="text-indigo-600 dark:text-indigo-300"
      />

      <MetricCard
        label="Taxa de Conversão"
        value={`${conversionRate.toFixed(2)}%`}
        icon={<BadgePercent />}
        bgColor="bg-teal-100 dark:bg-teal-900"
        iconColor="text-teal-600 dark:text-teal-300"
      />

      <MetricCard
        label="Ticket Médio"
        value={`R$ ${averageOrderValue.toLocaleString()}`}
        icon={<BadgeDollarSign />}
        bgColor="bg-rose-100 dark:bg-rose-900"
        iconColor="text-rose-600 dark:text-rose-300"
      />
    </div>
  );
};

export default CampaignMetricsCards;
